import {FC} from 'react'

import {useUser} from 'contexts/user'
import {PageViewTracker} from 'core/components/google-analytics'

export const PageViewTrackerWithUserId: FC = () => {
    const {user} = useUser()
    return <PageViewTracker userId={user?.id} />
}
